import { useContext, type ComponentProps } from 'react';
import { ThemeContext } from 'styled-components';
import VOIPIcon from './VOIPIcon';

/** VOIP glyph for a call that has both a primary and a secondary location. */
export default function AssociatedVOIPIcon(
  props: ComponentProps<typeof VOIPIcon>,
) {
  const theme = useContext(ThemeContext);
  return <VOIPIcon {...props} color={theme?.colors?.lightWarning} />;
}
